import React, { Fragment } from "react"
import PropTypes from "prop-types"
import Svg from "../_svgs/svg"
import { BrowserView, MobileView, isAndroid, isIOS } from "react-device-detect"

const SupportPanelItem = ({
  isMapsLink,
  linkTarget,
  fontColor,
  listBulletIcon,
  isUrl,
  listLinkTitle,
  listItemText,
  listItemUrl,
  latitude,
  longitude,
}) => {
  const svgColor = fontColor == "cph-white" ? "cph-white" : "cph-corp-blue"
  const svgBullet = <Svg isDecorative={true} iconClass={`icon ${svgColor}`} fillColor="transparent" iconName={listBulletIcon}></Svg>

  return (
    <Fragment>
      {isMapsLink ? (
        <li className="panel-item list-item-container">
          <BrowserView>
            <a
              target={linkTarget}
              className={`${fontColor} list-maps-link`}
              title={listLinkTitle}
              href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
            >
              {svgBullet}
              {listItemText}
            </a>
          </BrowserView>
          <MobileView>
            <a
              target={linkTarget}
              className={`${fontColor} list-maps-link`}
              title={listLinkTitle}
              href={
                isIOS
                  ? `maps://?q=${latitude},${longitude}`
                  : isAndroid
                    ? //Android with google maps installed know to open maps.google links in Google Maps.
                      `https://maps.google.com/?q=${latitude},${longitude}`
                    : `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`
              }
            >
              {svgBullet}
              {listItemText}
            </a>
          </MobileView>
        </li>
      ) : isUrl ? (
        <li className="panel-item list-item-container">
          <a target={linkTarget} className={`${fontColor} list-link`} title={listLinkTitle} href={listItemUrl}>
            {svgBullet}
            {listItemText}
          </a>
        </li>
      ) : (
        <li className="panel-item list-item-container-no-svg">
          <p className={`${fontColor} list-text`}>{listItemText}</p>
        </li>
      )}
    </Fragment>
  )
}

SupportPanelItem.propTypes = {
  isMapsLink: PropTypes.bool,
  linkTarget: PropTypes.string,
  fontColor: PropTypes.string,
  listLinkTitle: PropTypes.string,
  listItemText: PropTypes.array.isRequired,
  listItemUrl: PropTypes.string,
  latitude: PropTypes.string,
  longitude: PropTypes.string,
}

SupportPanelItem.defaultProps = {
  isMapsLink: false,
  linkTarget: "_blank",
  fontColor: "cph-white",
  listLinkTitle: "",
  listItemUrl: "",
  latitude: "",
  longitude: "",
}

export default SupportPanelItem
